import { Component } from 'react';

import Field from '../forms/Field';
import TextInput from '../inputs/DeprecatedTextInput';

interface Props {
  autoComplete?: boolean;
  'data-testid'?: string;
  disabled?: boolean;
  field: ReduxFormField<string>;
  maxLength: number;
  label?: string;
  id?: string;
}

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
export default class CVCInput extends Component<Props> {
  render() {
    const { autoComplete, disabled, field, maxLength, label, id } = this.props;

    return (
      <Field field={field} label={label} labelFor={id}>
        <TextInput
          id={id}
          autoComplete={autoComplete ? 'cc-csc' : 'off'}
          autoCorrect="off"
          disabled={disabled}
          data-testid={this.props['data-testid']}
          field={field}
          maxLength={maxLength}
          pattern="\d*"
          type="tel"
          placeholder="CVC"
        />
      </Field>
    );
  }
}
